var _rect, _path, _path2, _circle, _path3, _circle2, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDissatisfied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFD663"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07406 14.5C1.02508 14.9934 1 15.4938 1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16C31 15.4937 30.9749 14.9934 30.9259 14.5C30.1733 22.08 23.778 28 16 28C8.22198 28 1.82665 22.08 1.07406 14.5Z",
    fill: "#FFD04C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6838 22.9487C12.2077 23.1233 12.774 22.8402 12.9487 22.3162C13.3511 21.109 14.4356 20 16 20C17.5644 20 18.6489 21.109 19.0513 22.3162C19.226 22.8402 19.7923 23.1233 20.3162 22.9487C20.8402 22.774 21.1233 22.2077 20.9487 21.6838C20.3511 19.891 18.6461 18 16 18C13.3539 18 11.6489 19.891 11.0513 21.6838C10.8767 22.2077 11.1598 22.774 11.6838 22.9487Z",
    fill: "#52565F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13,
    r: 2,
    fill: "#52565F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05131 10.6838C7.22596 10.1598 7.79228 9.87667 8.31622 10.0513L14.3162 12.0513C14.8402 12.226 15.1233 12.7923 14.9487 13.3162C14.774 13.8402 14.2077 14.1233 13.6838 13.9487L7.68377 11.9487C7.15983 11.774 6.87667 11.2077 7.05131 10.6838Z",
    fill: "#52565F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 13,
    r: 2,
    fill: "#52565F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9487 10.6838C24.774 10.1598 24.2077 9.87667 23.6838 10.0513L17.6838 12.0513C17.1598 12.226 16.8767 12.7923 17.0513 13.3162C17.226 13.8402 17.7923 14.1233 18.3162 13.9487L24.3162 11.9487C24.8402 11.774 25.1233 11.2077 24.9487 10.6838Z",
    fill: "#52565F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35357 15.6465C6.48748 15.7804 6.53424 15.9785 6.47436 16.1581L5.79058 18.2094L7.8419 17.5257C8.02157 17.4658 8.21965 17.5125 8.35357 17.6465C8.48748 17.7804 8.53424 17.9785 8.47436 18.1581L7.47436 21.1581C7.38703 21.4201 7.10387 21.5617 6.8419 21.4744C6.57993 21.387 6.43835 21.1039 6.52567 20.8419L7.20944 18.7906L5.15813 19.4744C4.97846 19.5342 4.78038 19.4875 4.64646 19.3536C4.51254 19.2197 4.46578 19.0216 4.52567 18.8419L5.20944 16.7906L3.15813 17.4744C2.89616 17.5617 2.613 17.4201 2.52567 17.1581C2.43835 16.8962 2.57993 16.613 2.8419 16.5257L5.8419 15.5257C6.02157 15.4658 6.21965 15.5125 6.35357 15.6465Z",
    fill: "#FB9C74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6464 15.6465C25.5125 15.7804 25.4658 15.9785 25.5256 16.1581L26.2094 18.2094L24.1581 17.5257C23.9784 17.4658 23.7803 17.5125 23.6464 17.6465C23.5125 17.7804 23.4658 17.9785 23.5256 18.1581L24.5256 21.1581C24.613 21.4201 24.8961 21.5617 25.1581 21.4744C25.4201 21.387 25.5617 21.1039 25.4743 20.8419L24.7906 18.7906L26.8419 19.4744C27.0215 19.5342 27.2196 19.4875 27.3535 19.3536C27.4875 19.2197 27.5342 19.0216 27.4743 18.8419L26.7906 16.7906L28.8419 17.4744C29.1038 17.5617 29.387 17.4201 29.4743 17.1581C29.5617 16.8962 29.4201 16.613 29.1581 16.5257L26.1581 15.5257C25.9784 15.4658 25.7803 15.5125 25.6464 15.6465Z",
    fill: "#FB9C74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDissatisfied);
export default __webpack_public_path__ + "static/media/dissatisfied.aa05da79bb7b3d20a4aeab733bbc8147.svg";
export { ForwardRef as ReactComponent };